import { baseSplitApi } from "../baseApi";

const basePath = '/operations'
const projectPath = `${basePath}/project`

export const projectsApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    getProject: build.query({
      query: (projectCode) => {
        return {
          url: `${projectPath}/${projectCode}`,
          method: 'GET'
        }
      },
      transformResponse: (response) => response.project
    }),
    getAllProjects: build.query({

      query: (queryObj) => {
        let getProjectUrl = `${projectPath}`
        if (queryObj?.status) {
          getProjectUrl += `?status=${queryObj.status}`
        }

        return {
          url: getProjectUrl,
          method: 'GET'
        }
      },
      transformResponse: (response) => response.projects
    })
  }),
  overrideExisting: false
})

export const selectProject = (projectCode) => projectsApi.endpoints.getProject.select(projectCode)


export const { useGetProjectQuery, useGetAllProjectsQuery } = projectsApi